import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Paper from '@material-ui/core/Paper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Stepper from '@material-ui/core/Stepper';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import * as Actions from '../actions/testForm';
import { ITestResultState } from '../reducers/testResult';
import i18n from '../resources/i18n';
import TestResultQuestion from './TestResultQuestion';

/**
 * テスト結果一問一ページ形式コンポーネントProps
 */
export interface ITestResultMultiPageProps extends ITestResultState {
	classes: {
		groupTitle: string;
		resultRight: string;
		resultWrong: string;
		root: string;
		titleFailed: string;
		titlePassed: string;
		question: string;
		questionImage: string;
		questionImageContainer: string;
		questionTitle: string;
		hint: string;
		table: string;
	};
	careerID: string;
	lang: string;
	questionGroupDisplay: boolean;
	testID: string;
}

interface IState {
	selectedGroup: number;
	selectedQuestion: number;
}

/**
 * テスト結果一問一ページ形式コンポーネント
 * @param props Props
 */
class TestResultMultiPage extends React.Component<
	ITestResultMultiPageProps,
	IState
> {
	constructor(props: ITestResultMultiPageProps) {
		super(props);

		this.state = {
			selectedGroup: 0,
			selectedQuestion: 0,
		};
	}

	public render() {
		const {
			careerID,
			lang,
			testID,
			classes,
			score,
			scoreMessage,
			questionGroupDisplay,
		} = this.props;
		const group = this.props.groups[this.state.selectedGroup];
		const question = group.questions[this.state.selectedQuestion];

		const title = `${score}${i18n.t('TestResultMultiPage_0001')}  ${i18n.t(
			scoreMessage,
			{ ns: 'force' }
		)}`;
		const titleClass = this.props.passFlg
			? classes.titlePassed
			: classes.titleFailed;
		const linkUrlParam: Actions.ILinkUrl = {
			careerID,
			lang,
			preview: true,
			testID,
		};
		return (
			<div className={classes.root}>
				<Typography variant="h6" className={titleClass}>
					{title}
				</Typography>
				<Grid container={true} spacing={1}>
					<Grid item={true} xs={3}>
						<Paper className={this.props.classes.table}>
							{this.table()}
						</Paper>
					</Grid>
					<Grid item={true} xs={9}>
						{questionGroupDisplay && (
							<Typography
								variant="h6"
								className={classes.groupTitle}
							>
								{group.groupTitle}
							</Typography>
						)}
						<TestResultQuestion
							question={question}
							classes={classes}
							linkUrlParam={linkUrlParam}
						/>
					</Grid>
				</Grid>
			</div>
		);
	}

	protected table() {
		const { classes, groups, questionGroupDisplay } = this.props;
		const { selectedGroup, selectedQuestion } = this.state;
		return groups.map((group, i) => {
			const activeStep = i === selectedGroup ? selectedQuestion : -1;
			return (
				<div key={i}>
					{questionGroupDisplay && (
						<Typography variant="h6" className={classes.groupTitle}>
							{group.groupTitle}
						</Typography>
					)}
					<Stepper
						activeStep={activeStep}
						nonLinear={true}
						orientation="vertical"
					>
						{group.questions.map((question, j) => {
							let messageClass: string | undefined;
							if (question.answerResultType === 1) {
								messageClass = classes.resultRight;
							} else if (question.answerResultType === 2) {
								messageClass = classes.resultWrong;
							}
							return (
								<Step key={j}>
									<StepButton
										onClick={this.handleSelectQuestion(
											i,
											j
										)}
									>
										<Hidden xsDown={true}>
											<Typography
												className={messageClass}
											>
												{question.questionNo}
											</Typography>
										</Hidden>
									</StepButton>
								</Step>
							);
						})}
					</Stepper>
				</div>
			);
		});
	}

	/**
	 * 問題選択ハンドラ
	 */
	protected handleSelectQuestion = (
		group: number,
		question: number
	) => () => {
		this.setState({
			selectedGroup: group,
			selectedQuestion: question,
		});
	};
}

export default TestResultMultiPage;



// WEBPACK FOOTER //
// ./src/components/TestResultMultiPage.tsx